import React from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import Bullets from 'slickpay/common/Bullets.component';

import IMG_KPI_STAFF from 'assets/images/reports/ipad-kpi-report.png';
import Button from 'components/form/Button.component';
import LINK from 'constants/link.const';
import S from 'constants/string.const';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import linkTo from 'utils/links/linkTo.util';
import C from 'utils/values/constant.util';

import CN from './StaffKpiSplash.module.scss';

const DATA = C([
  'Allow your staff to see their KPIs only',
  'Filter by any date range and compare periods',
  `Compare KPIs to-date vs forecast`,
]);

const StaffKpiSplash = ({ title }) => {
  const { isDarkMode } = useTheme();
  const salonId = useCurrentSalonId();

  const summaryKpiLink = linkTo({ pattern: LINK.slnStaffReportsKpi, params: { salonId }, fault: '#' });

  return (
    <div
      data-bem="StaffKpiSplash"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.spotLeft} />
      <div className={CN.spotRight} />

      <div className={CN.container}>
        <div className={CN.title}>
          {title} {S.arrowUpR}
        </div>

        <div className={CN.flex}>
          <div className={CN.listContainer}>
            <div className={CN.subTitle}>We have upgraded our staff KPI reports! You can now:</div>
            <Bullets data={DATA} star />

            <div className={CN.buttonContainer}>
              <NavLink to={summaryKpiLink}>
                <Button variant="large" onClick={alwaysNoop}>
                  VIEW STAFF KPI REPORTS
                </Button>
              </NavLink>
            </div>
          </div>
          <div className={CN.imageContainer}>
            <img src={IMG_KPI_STAFF} alt="Illustration kpi future page" className={CN.image} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffKpiSplash;
